import Fieldset from '@/components/Fieldset';
import { ImageFromServer } from '@/components/images/ImageFromServer';
import { ExerciseDTO } from '@/generated';
import { FitnessCenter } from '@mui/icons-material';
import { Card, CardContent, Grid, Stack, Typography, Box } from '@mui/material';
import { useBodyZoneListQuery, useEquipmentListQuery } from '@/hooks/query-hooks';
import { PrimaryValueIcon } from '@/components/PrimaryValueIcon';

interface CardExerciseProps {
  exercise: ExerciseDTO;
  timeout: number;
}

export const ExerciseCard = (props: CardExerciseProps) => {
  const { equipmentList } = useEquipmentListQuery();
  const { bodyZoneList } = useBodyZoneListQuery();
  const { exercise } = props;
  return (
    <Card sx={{ width: '100%', maxWidth: 350 }}>
      <CardContent>
        <Grid container columnSpacing={2} rowSpacing={1.5}>
          <Grid size={5}>
            <ImageFromServer sx={{ width: '100%', maxWidth: 100, maxHeight: 100, objectFit: 'contain' }} thumbnail={true} alt="" id={exercise.imageId} />
          </Grid>

          <Grid size={7} sx={{ minWidth: 0 }}>
            <Stack gap={0.5}>
              <Typography sx={{ overflowWrap: 'anywhere' }} variant="body1">
                {props.exercise.name}
              </Typography>
              <Typography variant="body2">{bodyZoneList?.find((bz) => bz.id === props.exercise.mainBodyZoneId)?.name ?? 'N.A.'}</Typography>
              <Stack direction="row" gap={2} useFlexGap flexWrap="wrap" sx={{ pt: 0.5 }}>
                <Stack direction="row" gap={0.75} sx={{ alignItems: 'center', minWidth: 0 }}>
                  <PrimaryValueIcon executionType={props.exercise.config.executionType} />
                  <Typography variant="body2">{props.exercise.config.value ?? '-'}</Typography>
                </Stack>
                <Stack direction="row" gap={0.75} sx={{ alignItems: 'center', minWidth: 0 }}>
                  <FitnessCenter fontSize="small" />
                  <Typography variant="body2">{props.exercise.config.weight || '-'}</Typography>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
